import React, { useContext } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AffiliateNavbar from "./components/AffiliateNavbar";
import PayoutSetupReminder from "./components/PayoutSetupReminder";
import AffiliateTermsGate from "./AffiliateTermsGate";
import PartnerTermsGate from "./PartnerTermsGate";
import { AffiliateAuthContext } from "./context/AffiliateAuthContext";
import { isPartnerKind } from "./utils/portalKind";
import { surfaces, effects } from "../design-system/tokens";

const AffiliateDashboard = () => {
  const { affiliateAuth } = useContext(AffiliateAuthContext) || {};
  const location = useLocation();
  const terms = affiliateAuth?.terms;
  const isPartner = isPartnerKind(affiliateAuth?.user);
  // Only gate once the session check has answered, so the portal does not flash
  // the terms screen for a user who already accepted them. The check payload's
  // terms block is kind-aware server-side; the gate component follows the kind.
  const needsTermsAcceptance = !!terms && terms.accepted === false;
  const TermsGate = isPartner ? PartnerTermsGate : AffiliateTermsGate;
  // My Payments renders its own reminder above its page title — avoid a second copy from the shell.
  const isPaymentsTab = /\/(affiliate|partner)\/dashboard\/payments\/?$/.test(location.pathname);

  return (
    <div className={`min-h-screen ${surfaces.modernApp} transition-colors duration-300 relative`}>
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        <div className={effects.backgroundGlowBlue}></div>
        <div className={effects.backgroundGlowSky}></div>
      </div>

      <div className="relative z-10">
        <AffiliateNavbar showTabs={!needsTermsAcceptance} />
        {needsTermsAcceptance ? (
          <TermsGate requiredVersion={terms.required_version} />
        ) : (
          <>
            {/* Partners have no payouts — never show the payout setup banner for them. */}
            {!isPaymentsTab && !isPartner ? <PayoutSetupReminder /> : null}
            <Outlet />
          </>
        )}
      </div>
    </div>
  );
};

export default AffiliateDashboard;
